import Vue from "vue";

export default {
  login(credentials) {
    return Vue.axios
      .post("api/v1/login", credentials)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  },
  refresh(refresh_token) {
    return Vue.axios
      .post("api/v1/refresh", { refresh_token })
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  },
  logout() {
    return Vue.axios
      .post("api/v1/logout")
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  },
  userinfo() {
    return Vue.axios
      .get("api/v1/userinfo")
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  },
};
